import CityService from "../../service/CityService.js";
import SystemConfigurationService from '../../service/SystemConfigurationService';

class SheetDefaultData{

       
  static async findCityByNameAndState(address){
    let city = {}
    try {
      let cities = await CityService.getAll();
      for (let i = 0; i < cities.length; i++) {
        if(address.city.toUpperCase() == cities[i].name.toUpperCase() && address.state.toUpperCase() == cities[i].uf.toUpperCase()){
          return cities[i];
        }
      }
    } catch (error) {
      console.log(error);
    }
    return city
  }

  static async getHeader(budget){
    let systemConfigurations = await SystemConfigurationService.getConfigurations()
    let address = {sectorType: "SEDE", sector:"SEDE"}
    if(budget && budget.client && budget.client.address){
      address.cityOfService       = await this.findCityByNameAndState(budget.client.address)
      address.complement          = budget.client.address.complement
      address.district            = budget.client.address.district
      address.number              = budget.client.address.number
      address.addressType         = budget.client.address.addressType
      address.cep                 = budget.client.address.cep
    } else{
      address.sectorType    = "",
      address.cityOfService = {},
      address.name          = "",
      address.complement    = "",
      address.district      = "",
      address.number        = "",
      address.addressType   = "",
      address.cep           = "",
      address.sector        = "SEDE"
    }
    let header = {
      deliveryAddress: address,
      professionalCategory: {
        occupation:{},
        basicSalary: 0,
        cbo: ""
      },
      unitOfMeasurement: "Posto de Serviço",
      numberOfEmployees: 1,
      dataBaseOfTheCategory: new Date().toISOString().substr(0, 10),
      minimalSalary: 0,
      mainNotes: systemConfigurations.sheetDefault.header.mainNotes,
      complementariesNotes: systemConfigurations.sheetDefault.header.complementariesNotes,
      amountMonthly: 0
    }
    return header
  }
  static async getModuleOne(){
    let systemConfigurations = await SystemConfigurationService.getConfigurations()

    let moduleOne = {
      serviceStationGratification: [],
      percentOfAdditionalHealth: 0,
      percentOfAdditionalDanger: 0,
      additionalNocturne: {
        has: false,
        workedHours: 0,
        percent: 0,
        workJournie: 0
      },
      extraHour: {
        has: false,
        workJournie: 0,
        hours50: 0,
        hours75: 0,
        hours100: 0
      },
      others:[],
      dsr: {},
      notes: systemConfigurations.sheetDefault.moduleOne.notes
    }

    return moduleOne;
  }
  static async getModuleTwo(){
    let systemConfigurations = await SystemConfigurationService.getConfigurations()
    let moduleTwo = {
      fap: 0.5,
      fgts: 8,
      incra: 0.2,
      inss: 20,
      educationSalary: 2.5,
      foodAid:{
        has: false,
        mealByDay: 0,
        daysByMonth: 0,
        value: 0,
      },
      others:[{
        description: 'Benefício Social Familiar',
        value: 9.7
      },
      {
        description: 'Benefício Assistencial',
        value: 4
      }],
      rat: 2,
      sebrae: 0.6,
      senaiSenac: 1,
      sesiSesc: 1.5,
      thirteenFirstSalary: 8.33,
      transport:{
        has: false,
        ticketByDay: 0,
        daysByMonth: 0,
        tariffValue: 0,
      },
      vacationAdditional: 11.11,
      notesOne: systemConfigurations.sheetDefault.moduleTwo.notesOne,
      notesTwo: systemConfigurations.sheetDefault.moduleTwo.notesTwo,
      notesThree: systemConfigurations.sheetDefault.moduleTwo.notesThree,
    }

    return moduleTwo;
  }
  static async getModuleThree(){
    let systemConfigurations = await SystemConfigurationService.getConfigurations()

    let fgts = 0.08
    let amountOfModuleTwoTwoPercent = 0
    let basisIndemnifiedValue = (0.05 * (1 / 12)) * 100
    let basisWorkedValue = ((7 / 30) / 12) *  100
    let moduleThree =  {
      previousNoticeIndemnified: basisIndemnifiedValue,
      fgtsIncidencePreviousNoticeIndemnified: basisIndemnifiedValue * fgts / 100,
      fgtsPenaltyPreviousNoticeIndemnified: 100 * ((0.08*(0.4+0.1)*0.9)*((1+5/56+5/56)+(1/3*5/56))),
      previousNoticeWorked: basisWorkedValue,
      fgtsIncidencePreviousNoticeWorked: amountOfModuleTwoTwoPercent * basisWorkedValue / 100,
      fgtsPenaltyPreviousNoticeWorked: 0.08 * (0.4 + 0.1) * basisWorkedValue
    }

    return moduleThree;
  }
  static async getModuleFour(){
    let systemConfigurations = await SystemConfigurationService.getConfigurations()
    let moduleFour = {
      vacation: (1 / 12) * 100,
      legalAbsences: (5 / 360) * 100,
      paternityLicence: (5 / 365 * 0.015) * 100,
      workAccident: 15 / 360 * 3.02,
      maternityLicence: (0.5*0.01416*(4/12)*(0.0893+0.0893+0.0298)) * 100,
      professionalAbsent: 0,
      restAndFeeding: 0,
      others: [],
      notes: systemConfigurations.sheetDefault.moduleFour.notes,
    }

    return moduleFour;
  }
  static async getModuleFive(){
    let systemConfigurations = await SystemConfigurationService.getConfigurations()

    let moduleFive = {
      consumables: {
        bond: null,
        depreciation: false,
        items:[]
      },
      equipments: {
        bond: null,
        depreciation: false,
        items:[]
      },
      
      uniformsAndEPIs: {
        bond: null,
        depreciation: false,
        items:[]
      },
      utensils: {
        bond: null,
        depreciation: false,
        items:[]
      },
      others:[],
      notes: systemConfigurations.sheetDefault.moduleFive.notes
    }

    return moduleFive;
  }
  static async getModuleSix(){
    let systemConfigurations = await SystemConfigurationService.getConfigurations()

    let moduleSix = {
      administrativeCosts: 0,
      lucre: 0,
      others: [],
      notes: systemConfigurations.sheetDefault.moduleSix.notes
    }

    return moduleSix;
  }
}
export default SheetDefaultData;



// WEBPACK FOOTER //
// ./src/data/sheet/SheetDefaultData.js